<template>
  <Form :model="formData" ref="createBomVersionForm" :rules="ruleValidate" label-position="top">
    <FormItem :label="$t('version_number')" prop="version">
      <Input v-model="formData.version" :placeholder="$t('bom_tool.bom_version_number_placeholder')"></Input>
    </FormItem>
    <FormItem :label="$t('bom_tool.log_message')" prop="message">
      <Input v-model="formData.message" type="textarea" :placeholder="$t('bom_tool.log_message_placeholder')"></Input>
    </FormItem>
    <FormItem v-if="!wrappedInModal">
      <Button type="primary" @click="handleSubmit" :loading="loading">{{ $t('bom_tool.create_new_version') }}</Button>
    </FormItem>
  </Form>
</template>
<script>

import { mapActions } from 'vuex'
export default {
  name: 'BOMNewRevisionForm',
  props: {
    bomId: Number,
    currentVersion: String,
    wrappedInModal: { type: Boolean, default: false }
  },
  data () {
    return {
      formData: { version: '', message: '' },
      loading: false,
      ruleValidate: {
        version: [
          { required: true, type: 'string', message: 'Version number cannot be empty!', trigger: 'change' }
        ],
        message: [
          { required: true, type: 'string', message: 'Please describe the changes!', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    ...mapActions(['createBomVersion']),
    handleSubmit (fn = null) {
      return this.$refs['createBomVersionForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          return this.createBomVersion({ id: this.bomId, data: this.formData })
            .then((res) => {
              this.$emit('versionCreated', res.data)
              if (fn) fn(res.data)
            })
            .finally(() => {
              this.$emit('on-saving-finished')
              this.loading = false
            })
        }
      })
    }
  },
  watch: {
    'formData.version' () {
      this.loading = false
    }
  }
}
</script>
